import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPECS, 
	GET_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPEC,
	CREATE_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPEC,
	UPDATE_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPEC,
	DESTROY_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPEC,
} from "./actions"

export function ProjectQaWeldingInspectionsInspectionSpecsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPECS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPEC}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPEC}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPEC}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTIONS_INSPECTION_SPEC}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsInspectionSpecsReducer } from "modules/project/qa/welding_inspections/inspection_specs/reducer"

// project_qa_welding_inspections_inspection_specs:ProjectQaWeldingInspectionsInspectionSpecsReducer,
